import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=64c0a72d&"
import script from "./ContactSection.vue?vue&type=script&lang=js&"
export * from "./ContactSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports